import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
const ABI_API_BASE = "https://contract-abi-api.b3.fun";
export interface TrendingContract {
  chainId: number;
  address: string;
  name: string;
  nameTag: string;
  explorerUrl: string;
  source: string;
}
interface TrendingContractsResponse {
  success: boolean;
  results: TrendingContract[];
  total: number;
  page: number;
  limit: number;
  sortBy: string;
}
interface UseTrendingContractsOptions {
  chainId?: number;
  limit?: number;
  enabled?: boolean;
}

/**
 * Hook to fetch trending contracts for a specific chain
 * Sorted by transaction volume in the last 30 days
 */
export function useTrendingContracts(t0) {
  const $ = _c(18);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    chainId,
    limit: t2,
    enabled: t3
  } = t1;
  const limit = t2 === undefined ? 20 : t2;
  const enabled = t3 === undefined ? true : t3;
  let t4;
  let t5;
  if ($[2] !== chainId || $[3] !== limit) {
    t4 = ["trending-contracts", chainId, limit];
    t5 = async () => {
      if (!chainId) {
        return {
          results: [],
          total: 0
        };
      }
      const response = await fetch(`${ABI_API_BASE}/list?chainId=${chainId}&sortBy=tx_30d&page=1&limit=${limit}`);
      if (!response.ok) {
        throw new Error(`Failed to fetch trending contracts: ${response.statusText}`);
      }
      const data = await response.json();
      return data;
    };
    $[2] = chainId;
    $[3] = limit;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  const t6 = enabled && !!chainId;
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6,
      staleTime: 300000,
      retry: 1
    };
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const query = useQuery(t7);
  let t8;
  if ($[10] !== query.data?.results) {
    t8 = query.data?.results || [];
    $[10] = query.data?.results;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = query.data?.total || 0;
  let t10;
  if ($[12] !== query.error || $[13] !== query.isLoading || $[14] !== query.refetch || $[15] !== t8 || $[16] !== t9) {
    t10 = {
      contracts: t8,
      total: t9,
      isLoading: query.isLoading,
      error: query.error,
      refetch: query.refetch
    };
    $[12] = query.error;
    $[13] = query.isLoading;
    $[14] = query.refetch;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}